/**/
$(document).ready(function () {
    /* Scroll to form -- start */
    $("a.atelierBanner__link").on("click", function (e) {
        e.preventDefault();

        // $(this).addClass('active');
        // $(this).siblings().removeClass('active');

        let href = $(this).attr("href");

        $("html, body").animate({
            scrollTop: $(href).offset().top-230
        }, {
            duration: 370,
            easing: "linear"
        });

        return false;
    });
    /* Scroll to form -- end */

    /* works slider -- start*/
    $('.atelierWorks__slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 300,
        variableWidth: true,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1180,
                settings: {
                    arrows: false
                }
            }
        ]
    });
    /* works slider -- end*/
});
